<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Documento de la comunidad</div>
        <div class='pt-2'><strong>{{ getDescripcion() }}</strong> - {{ getAmpliacion() }}</div>
      </div>
    </v-card-title>
  <div class="pa-2">
    <object 
      :data='getUrl()' 
      type='application/pdf' 
      width='100%' 
      height='600px'>
      <p>Este navegador no soporta la visualización de documentos PDF. Por favor descargue el documento para poder visualizarlo: 
        <a :href = 'getUrl()'>Descargar PDF</a>
      </p>
    </object>
  </div>
  </v-card>
     
</template>

<style>

</style>

<script>
import { mapState } from 'vuex'

export default {
    name: 'VerFacturaLiquidacion',
    props: {
      'idLiquidacion': { type: Number, required: true },
      'idDetalle': { type: Number, required: true },
      'idDocumento': { type: Number, required: true}
    },
    methods: {
        getUrl() {
            var detalle = this.detalles.find((detalle) => {
              return detalle.ID == this.idDetalle
            });

            var documento = detalle.DOCUMENTOS.find((documento) => {
              return documento.IDDOCUMENTO = this.idDocumento
            })

            return documento.URL
        },
        getDescripcion() {
            var detalle = this.detalles.find((detalle) => {
              return detalle.ID == this.idDetalle
            });

            return detalle.DESCRIPCION
        },
        getAmpliacion() {
            var detalle = this.detalles.find((detalle) => {
              return detalle.ID == this.idDetalle
            });

            return detalle.AMPLIACION
        }
    },
    computed: {
      ...mapState({
        detalles: state => state.liquidaciones.detalle_liquidacion
      })
    }
}
</script>

